import {
    getHeaders,
    getStorage,
    getOptionsOutput,
    getInputFileFont,
    getExtensionFromPath,
    getTempDirectory
} from '../../lib/skycity.js'

import { getParams } from '../params/psText.param.js'
import { getInputObj } from './testHelper.js'

export async function getConfig (curFile, outputOptions, iccProfileOption, layerOptions, inputSecondFiles) {
    const payload = await getCodePayload(curFile, outputOptions, iccProfileOption, layerOptions, inputSecondFiles)
    const config = {
        url: `${process.env.REACT_APP_CONFIG_ENDPOINT_PEGASUS}/psdService/text`,
        method: 'POST',
        timeout: 90000,
        headers: getHeaders(),
        payload: payload,
        body: JSON.stringify(payload)
    }
    return config
}

async function getCodePayload (curFile, outputOptions, iccProfileOption, layerOptions, inputSecondFiles) {
    const codePayload = {
        inputs: [{
            href: curFile.path || curFile.href,
            storage: getStorage(curFile)
        }],
        options: {
            layers: layerOptions
        },
        outputs: await getOptionsOutput(curFile, outputOptions, iccProfileOption)
    }
    if (inputSecondFiles && inputSecondFiles.length > 0) {
        codePayload.options.fonts = getInputFileFont(inputSecondFiles)
    }
    return codePayload
}

// ************************************************************************
// Test Cases
// ************************************************************************
export async function getTestCases (storages) {
    const testCases = await getParams(storages)
    const newTestCases = await Promise.all(testCases.map(async (testCase) => {
        const inputFileTypes = testCase.body.inputs.map(input => {
            return getExtensionFromPath(input.href)
        })
        const layerOptions = testCase.body.options.layers.map(layer => {
            // return `id: ${layer.id}`
            return JSON.stringify(layer)
        })
        const outputFileTypes = testCase.body.outputs.map(output => {
            return output.format.toUpperCase()
        })
        testCase = await prepareBodyForExternal(testCase)
        testCase.area = 'Photoshop API'
        testCase.feature = 'psText'
        testCase.desc = `${layerOptions} (${inputFileTypes} to ${outputFileTypes})`
        return testCase
    }))
    return newTestCases
}

export async function prepareBodyForExternal (options) {
    options.body.inputs = [await getInputObj(options.body.inputs[0])]
    options.body.outputs = options.body.outputs.map(output => {
        if (output.storage === 'adobe') {
            output.href = `${getTempDirectory()}/${output.href}`
        }
        return output
    })
    return options
}
